import React, { useState, useEffect } from 'react';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter,
  ModalCloseButton, Button, VStack, Text, Flex, Box, Checkbox,
} from '@chakra-ui/react';
import api from '../api';

export default function EngagementFilterModal({ isOpen, onClose, activeFilter, onApply }) {
  const [statuses, setStatuses] = useState([]);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (isOpen) {
      api.get('/lookups/engagement-statuses').then(({ data }) => setStatuses(data)).catch(() => {});
      setSelected(activeFilter || []);
    }
  }, [isOpen, activeFilter]);

  const toggle = (id) => {
    setSelected(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };

  const handleApply = () => { onApply(selected); onClose(); };
  const handleClear = () => { onApply([]); onClose(); };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <ModalOverlay /><ModalContent>
        <ModalHeader fontSize="md">Filter by Engagement</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={1} align="stretch">
            {statuses.map(s => (
              <Flex key={s.id} p={2} border="1px" borderColor={selected.includes(s.id) ? 'blue.400' : 'gray.100'}
                borderRadius="md" cursor="pointer" onClick={() => toggle(s.id)}
                bg={selected.includes(s.id) ? 'blue.50' : 'white'} align="center" gap={2}>
                <Checkbox size="sm" isChecked={selected.includes(s.id)} pointerEvents="none" />
                <Box w="10px" h="10px" borderRadius="full" bg={s.color || '#718096'} />
                <Text fontSize="12px" fontWeight="500">{s.name}</Text>
              </Flex>
            ))}
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button size="sm" variant="ghost" mr="auto" onClick={handleClear}>Clear Filter</Button>
          <Button size="sm" variant="ghost" mr={2} onClick={onClose}>Cancel</Button>
          <Button size="sm" bg="brand.600" color="white" _hover={{ bg: 'brand.700' }} onClick={handleApply}>Apply</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
